export const API_URL = 'https://explorer.omnirpc.io/graphql';
